<template>
  <div class="grade_main">
    <div class="head">学生缺勤信息</div>
    <div class="grade_top">
      <!-- <div class="tip">
        <span>当前节次缺勤总数：</span>
      </div> -->
      <!-- <grade-info ref="gradeInfo" v-if="!showClass" @to-class="toClass" />
      <class-info ref="classInfo" v-else @return-up="onReturn" /> -->
      <now-info ref="nowInfo" />
    </div>
  </div>
</template>
<script>
// import gradeInfo from "./grade";
// import classInfo from "./class";
import nowInfo from "./now";
export default {
  components: { 
    // gradeInfo,
    // classInfo,
    nowInfo
  },
  data() {
    return {
      showClass: false,
      source: [],
    };
  },
  methods: {
    setData(data) {
      this.source = data;
      this.$refs.nowInfo.setData(this.source);
    },
    // clear() {
    //   this.$refs.gradeInfo.clear();
    // },
    // toClass(data) {
    //   console.log("toClass", data);;

    //   if (data.SectionNumber > -100) {
    //     this.showClass = true;
    //     var params = {
    //       date: new Date(),
    //       section: data.SectionNumber,
    //       gradeId: data.GradeId,
    //     };
    //     var testtime = localStorage.getItem("index-test-time");
    //     if (testtime && testtime != "null") {
    //       params.date = testtime;
    //     }
    //     console.log("params", params, testtime);
    //     this.$nextTick(() => {
    //       this.$refs.classInfo.query(params);
    //     });
    //   } else {
    //     this.$message.warning("当前时间没有课程");
    //   }
    // },
    // onReturn() {
    //   this.showClass = false;
    //   this.$nextTick(() => {
    //     this.$refs.gradeInfo.setData(this.source);
    //   });
    // },
  },
};
</script>
<style lang="scss">
.grade_main {
  .row_tag {
    float: right;
    margin-left: 5px;
    min-width: 65px;
    text-align: center;
    @media screen and (max-width: 767px) {
      min-width: 45px !important;
    }
  }
  .head {
    line-height: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    cursor: default;
  }
  .grade_top {
    width: 100%;
    .btn_grade {
      font-size: 12px;
      cursor: pointer;
    }
    .btn_grade:hover {
      color: #409eff;
    }
  }
  .grade_bottom {
    width: 100%;
    margin-top: 10px;
  }
  .tip {
    font-size: 14px;
    text-align: left;
    color: #484848;
    line-height: 54px;
  }
}
</style>